import dayjs from "dayjs"
import isToday from "dayjs/plugin/isToday"

dayjs.extend(isToday)

export const roundUpToHalfHour = (date: dayjs.Dayjs): dayjs.Dayjs => {
  const remainderMinutes = date.minute() % 30
  const rounded = date.subtract(remainderMinutes, "minutes").add(30, "minutes")

  return remainderMinutes !== 0 ? rounded : date.clone()
}

export const getCompletionMessage = (
  completionTime: string | undefined,
): string => {
  const completionDate = dayjs(completionTime)

  if (!completionTime || completionDate.isBefore(dayjs())) {
    return "We expect to be back soon"
  }

  const isToday = completionDate.isToday()
  const isSoon = completionDate.diff(dayjs(), "hours") < 1
  const isVerySoon = completionDate.diff(dayjs(), "minutes") < 15
  const date = isSoon
    ? ""
    : isToday
      ? "today"
      : completionDate.format("MMMM D,")
  const time = isVerySoon
    ? "soon"
    : isSoon
      ? `in ${
          Math.round(completionDate.diff(dayjs(), "minutes") / 5) * 5
        } minutes`
      : `by ${roundUpToHalfHour(completionDate).format("h:mm A")}`

  return `We expect to be back ${date} ${time}`
}
